module.exports = __webpack_public_path__ + "static/img/衣创社区小程序.cf0b6046.jpg";